const style = {
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  boxMain: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  gapBox: {
    gap: '15px',
  },
  title: {
    variant: 'h4',
  },
} as const;

export default style;
